export default function PoiDetailSkeleton() {
  return (
    <>
      <div className='w-full aspect-[360/200] skeleton-item'></div>
      <div className='pt-20pxr px-20pxr flex flex-col gap-8pxr'>
        <div className='skeleton-item w-100pxr h-20pxr rounded-4pxr'></div>
        <div className='flex flex-col gap-12pxr'>
          <div className='skeleton-item w-full h-24pxr rounded-4pxr mb-2pxr'></div>

          <div className='flex flex-col gap-4pxr'>
            <div className='skeleton-item w-full h-16pxr rounded-4pxr'></div>
            <div className='skeleton-item w-full h-16pxr rounded-4pxr'></div>
            <div className='skeleton-item w-3/4 h-16pxr rounded-4pxr'></div>
          </div>
        </div>
      </div>
      <div className='w-full h-10pxr my-30pxr bg-new-gray-100 border-y border-new-gray-300'></div>
      <div className='px-20pxr pb-80pxr flex flex-col gap-20pxr'>
        <div className='flex flex-col gap-20pxr'>
          <div className='skeleton-item w-1/3 h-20pxr rounded-4pxr'></div>
          <div className='flex flex-col gap-16pxr'>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className='flex flex-col gap-8pxr'>
                <div className='skeleton-item w-2/3 h-18pxr rounded-4pxr'></div>
                <div className='skeleton-item w-full h-18pxr rounded-4pxr'></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
